import React from 'react';
import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import getWorkingHoursFormat from './getWorkingHoursFormat';
import useWorkScheduleCalendarContext from '../context/useWorkScheduleCalendarContext';

export default function ScheduleSummary() {
  const { t } = useTranslation();
  const { workSchedules } = useWorkScheduleCalendarContext();

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      sx={{
        '& .MuiTypography-root': {
          userSelect: 'none',
        },
      }}
    >
      <Stack>
        <Typography variant="caption" color="text.secondary">
          {t('label.working_hours')}
        </Typography>
        <Typography variant="h6">
          {getWorkingHoursFormat(workSchedules)}
        </Typography>
      </Stack>
    </Stack>
  );
}
